import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb207f9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-popup-container__navigation detail-container__navigation" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "info-popup-container__navigation-svg--close detail-container__navigation-svg--close" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "info-popup-container__navigation-body detail-container__navigation-body"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "info-popup-container__navigation-svg--share detail-container__navigation-svg--share" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createBlock(_component_vue_final_modal, _mergeProps(_ctx.$attrs, {
    classes: "modal-container detail-container",
    "content-class": "modal-content detail-content"
  }), {
    default: _withCtx(({ close, params }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "info-popup-container__navigation-body detail-container__navigation-body",
          onClick: close
        }, _hoisted_4, 8, _hoisted_2),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "content", { params: params }, undefined, true)
      ])
    ]),
    _: 3
  }, 16))
}